const BASE_URL = process.env.REACT_APP_BASE_URL;

export const ApiRequestInterceptor = async (path, method, body, header = {}) => {
  try {
    const params = ApiRequestParamsFormatter(method, body, header);
    const response = await fetch(`${BASE_URL}/${path}`, params);
    return ApiRequestFormatter(response);
  } catch (exception) {
    //TODO Handle Exception Pendient
    return {
      error: 500,
      data: null,
    };
  } finally {
    //TODO Handle Loading
  }
};

const ApiRequestParamsFormatter = (method, body, header) => {
  const headers = ApiRequestHeaderFormatter(header);

  return method !== "GET" && body
    ? {
      method,
      body: JSON.stringify(body),
      headers,
    }
    : { method, headers };
};

const ApiRequestFormatter = async (response) => {
  const code = response.status;
  let data = null;

  if (
    response.headers.get("content-type")?.includes("application/json")
  ) {
    try {
      data = await response.json();
    } catch (e) {
      data = null;
    }
  }

  return { code, data };
};


const ApiRequestHeaderFormatter = (header) => {
  let headers = new Headers();

  for (const key in header) {
    headers.append(key, header[key]);
    headers.append("Content-Type", "application/json");
  }

  return headers;
};
